export default __webpack_public_path__ + "static/manageHouses2-193a65c09bd1c77985d2f84a5e0f19f6.png";